(() => {
  const cart = document.getElementById('cart');
  const veil = document.getElementById('cartVeil');
  const itemsEl = document.getElementById('cartItems');
  const subtotalEl = document.getElementById('cartSubtotal');
  const countEl = document.getElementById('cartCount');

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const openCart = (open) => {
    if (!cart) return;
    cart.classList.toggle('open', open);
    cart.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (veil) veil.classList.toggle('open', open);
    document.documentElement.classList.toggle('lume-cart-open', open);
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lume-cart-open]')) {
      e.preventDefault();
      refresh().then(() => openCart(true));
    }
    if (e.target.closest('[data-lume-cart-close]')) {
      openCart(false);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') openCart(false);
  });

  /* Homepage + collection cards — must live here (lume-product.js is PDP-only) */
  document.addEventListener('click', async (e) => {
    const need = e.target.closest('[data-lume-need-product]');
    if (need) {
      e.preventDefault();
      if (window.LUME && LUME.toast) {
        LUME.toast('Assign each Key product in Theme Editor → Four Keys');
      }
      return;
    }
    const addBtn = e.target.closest('[data-lume-add]');
    if (!addBtn) return;
    e.preventDefault();
    const id = addBtn.getAttribute('data-variant-id') || addBtn.dataset.variantId;
    if (!id) {
      if (window.LUME && LUME.toast) LUME.toast('Product variant missing');
      return;
    }
    if (typeof LUME.addToCart !== 'function') return;
    addBtn.disabled = true;
    try {
      await LUME.addToCart(id, 1);
    } catch (err) {
      /* toast already shown */
    } finally {
      addBtn.disabled = false;
    }
  });

  async function refresh() {
    const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    const data = await res.json();
    render(data);
    return data;
  }

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function render(data) {
    if (countEl) {
      countEl.textContent = String(data.item_count || 0);
      countEl.classList.toggle('show', (data.item_count || 0) > 0);
    }
    if (subtotalEl && window.LUME && LUME.formatMoney) {
      subtotalEl.textContent = LUME.formatMoney(data.total_price || 0);
    }

    if (!itemsEl) return;

    while (itemsEl.firstChild) itemsEl.removeChild(itemsEl.firstChild);

    if (!data.items || !data.items.length) {
      const empty = el('p', 'cart-empty');
      empty.appendChild(document.createTextNode('Your cart is empty.'));
      empty.appendChild(document.createElement('br'));
      empty.appendChild(document.createTextNode('Choose a Key to begin.'));
      itemsEl.appendChild(empty);
      return;
    }

    data.items.forEach((item) => {
      const row = el('div', 'cart-item');
      row.dataset.key = item.key;

      const imgWrap = el('div', 'cart-item-img');
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        imgWrap.appendChild(img);
      }
      row.appendChild(imgWrap);

      const body = el('div', 'cart-item-body');
      body.appendChild(el('div', 'cart-item-title', item.product_title));
      body.appendChild(el('div', 'cart-item-price', LUME.formatMoney(item.final_line_price)));

      const qty = el('div', 'cart-item-qty');
      const minus = el('button', null, '−');
      minus.type = 'button';
      minus.dataset.qtyChange = '-1';
      minus.setAttribute('aria-label', 'Decrease');
      const span = el('span', null, String(item.quantity));
      const plus = el('button', null, '+');
      plus.type = 'button';
      plus.dataset.qtyChange = '1';
      plus.setAttribute('aria-label', 'Increase');
      qty.appendChild(minus);
      qty.appendChild(span);
      qty.appendChild(plus);
      body.appendChild(qty);
      row.appendChild(body);
      itemsEl.appendChild(row);
    });
  }

  if (itemsEl) {
    itemsEl.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const row = btn.closest('.cart-item');
      const key = row && row.dataset.key;
      const delta = Number(btn.dataset.qtyChange);
      const span = row.querySelector('.cart-item-qty span');
      const next = Math.max(0, Number(span.textContent) + delta);
      await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: next }),
      });
      await refresh();
    });
  }

  window.LUME = window.LUME || {};

  LUME.addToCart = async (variantId, quantity = 1) => {
    const id = Number(variantId);
    const qty = Number(quantity) || 1;
    if (!id) {
      LUME.toast('Could not add to cart');
      throw new Error('missing variant');
    }
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] }),
    });
    if (!res.ok) {
      let msg = 'Could not add to cart';
      try {
        const err = await res.json();
        if (err && err.description) msg = err.description;
        else if (err && err.message) msg = err.message;
      } catch (e) { /* ignore */ }
      LUME.toast(msg);
      throw new Error(msg);
    }
    await refresh();
    openCart(true);
    LUME.toast('Added to cart');
  };

  const remindBtn = document.getElementById('remindBtn');
  const remindInput = document.getElementById('remindInput');
  if (remindBtn && remindInput) {
    const saved = localStorage.getItem('lume_remind');
    if (saved) remindInput.value = saved;
    remindBtn.addEventListener('click', () => {
      const v = remindInput.value.trim();
      if (!v) return LUME.toast('Enter a WhatsApp number');
      localStorage.setItem('lume_remind', v);
      LUME.toast('Reminders saved');
    });
  }

  refresh().catch(() => {});
})();
